(function(angular) {
    'use strict';
    angular.module('aprima-core-ui').component('tinymce', {
        bindings: {
            removeFormatting : '<',
            hideToolbar : '<',
            useAdvancedToolbar : '<',
            value: '=',
            height: '<',
            valueChanged: '&',
        },
        templateUrl: '/core-ui/component-views/tinymce.html',
        controller: [
            Tinymce,
        ],
    });

    function Tinymce() {
        var vm = this;
        var simpleToolbar = 'cut | copy | paste | undo | redo | removeformat | help | fullscreen | insertdatetime';
        var advancedToolbar = ' cut copy undo redo | alignleft aligncenter alignright | fontselect styleselect fontsizeselect | bold italic underline strikethrough | bullist numlist |  removeformat | help | fullscreen | insertdatetime';
        var toolbarSelected;

        if (vm.hideToolbar){
            toolbarSelected = false;
        } else if(vm.useAdvancedToolbar){
            toolbarSelected = advancedToolbar;
        } else {
            toolbarSelected = simpleToolbar;
        }

        vm.tinymceModelOptions = {
            debounce: 300,
        };
        vm.tinymceOptions = {
            branding: false,
            toolbar: toolbarSelected,
            plugins: 'fullscreen',
            menubar: false,
            statusbar: false,
            resize : false,
            height : vm.height,
            format : (vm.removeFormatting) ? 'text' : 'raw',
            /* jshint camelcase:false */
            browser_spellcheck: true,
            remove_linebreaks : true
            /* jshint camelcase:true */
        };

        vm.onChange = onChange;

        function onChange() {
            vm.valueChanged({
                updatedValue: vm.value,
            });
        }
    }
})(window.angular);